import { render, staticRenderFns } from "./knowDynamic.vue?vue&type=template&id=a7268d8a&scoped=true"
import script from "./knowDynamic.vue?vue&type=script&lang=js"
export * from "./knowDynamic.vue?vue&type=script&lang=js"
import style0 from "./knowDynamic.vue?vue&type=style&index=0&id=a7268d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7268d8a",
  null
  
)

export default component.exports